import { User, Users } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import { closeModal } from '@/app/slices/adminSettingsModalSlice';
import type { RootState } from '@/app/store';
import {
  Dialog,
  DialogBody,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';

import { Button, TabPanel, TabView } from '../compat-controls';
import GroupSettingsPanel from '../group-settings-panel';
import SettingsPanel from '../vet-settings-panel';

export function AdminSettingsModal() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const isOpen = useSelector(
    (state: RootState) => state.adminSettingsModal.open,
  );
  const activeTab = useSelector(
    (state: RootState) => state.adminSettingsModal.tab,
  );
  const activeIndex = activeTab === 'groups' ? 1 : 0;

  const hide = () => dispatch(closeModal());

  return (
    <Dialog
      open={isOpen}
      onOpenChange={(nextOpen) => {
        if (!nextOpen) hide();
      }}
    >
      <DialogContent className="md:max-w-2xl">
        <DialogHeader>
          <DialogTitle>{t('serviceScheduler.adminSettings')}</DialogTitle>
        </DialogHeader>

        <DialogBody>
          <TabView renderActiveOnly activeIndex={activeIndex}>
            <TabPanel
              header={
                <span className="flex items-center gap-2">
                  <User className="size-4" /> {t('serviceScheduler.psePsv')}
                </span>
              }
            >
              <SettingsPanel />
            </TabPanel>

            <TabPanel
              header={
                <span className="flex items-center gap-2">
                  <Users className="size-4" /> {t('serviceScheduler.groups')}
                </span>
              }
            >
              <GroupSettingsPanel />
            </TabPanel>
          </TabView>
        </DialogBody>

        <DialogFooter>
          <Button
            label={t('common.cancel')}
            severity="secondary"
            onClick={hide}
          />
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
